<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'flavor_list', params: { search: search}}" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">線上點餐管理 / 調味管理 / 項目維護</b-col>
            <b-col>
            </b-col>
        </b-row>
        <div id="func-content">
            <!-- Second Data Table Starts Here-->
                    <b-card class="bg-default-card">
                        <div class="row">
                            <div class="col-lg-12">
                                <label class="control-label" >調味名稱： </label>{{ this.$route.params.menuname}}
                                <div class="" header="Form Elements">
                                    <div class="float-right">
                                        <button type="button" class="btn btn-outline-light" v-if="btn_order && FunctionPermission > 1" @click="editByOpen('add')">新增</button>
                                        <button type='button' class='btn btn-warning text-white' v-show='btn_order && FunctionPermission > 1' @click='editOrderBy' >重新排序</button>
                                        <!-- 排序用按鈕 -->
                                        <button type='button' class='btn btn-save' v-show='!btn_order && FunctionPermission > 1' @click='OrderByOpen'>儲存</button>
                                        <button type='button' class='btn btn-clear' v-show='!btn_order && FunctionPermission > 1' @click='orderCancel'>取消</button>
                                    </div>
                                    <div class="table-responsive" style="padding-top:10px">
                                        <table id="mytable" class="table table-bordred table-striped">
                                            <thead>
                                                <tr>
                                                    <th>序號</th>
                                                    <th>項目名稱</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <draggable v-model='Datalist' element='tbody' :options="dragOptions">
                                                <tr v-for='(v, index) in Datalist' :key='v.id'>
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ v.ItemName }}</td>
                                                    <td class="text-right">
                                                      <button class='btn-circle btn-circle-ptc1' :disabled='!btn_order' v-show='FunctionPermission > 1' @click="editByOpen('edit',v)"><span class='fas fa-pencil-alt' title="編輯"></span></button>
                                                      <button class='btn-circle btn-circle-ptc1' :disabled='!btn_order' v-show='FunctionPermission > 1' @click='delByOpen(v)'><span class='fas fa-trash-alt' title="刪除"></span></button></td>
                                                </tr>
                                            </draggable>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
            <!-- ReSort Check Modal -->
      <b-modal ref="mdOrder" hide-footer title="排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="orderConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="mdOrderCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
     <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除 {{md_title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
      <b-modal ref="mdEdit" :no-close-on-backdrop="true" hide-footer :title="mdTitle" size="lg">
            <div class="d-block">
                <div class="col-lg-12 col-12 mb-3">
                  <div class="row col-lg-12" style="padding-top:10px">
                                            <div class="col-md-3">
                                                <label class="control-label">調味項目名稱：</label>
                                            </div>
                                            <div class="col-md-6">
                                              <input v-model="item_name" type="text" placeholder="" class="form-control" />
                                              <div class="text-danger" v-if="valid_item_name&&!item_name">{{valid_item_name}}</div>
                                            </div>
                    </div>
                </div>
                <div class="cog-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary"  @click="editsave()">儲存</b-btn>&nbsp;
                        <b-btn variant="secondary"  @click="editCancel()">取消</b-btn>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import draggable from 'vuedraggable'
Vue.use(VueForm, options)

export default {
  name: 'add_user',
  components: {
    draggable
  },
  data () {
    return {
      formstate: {},
      valid_errMsg: false,
      sort_action: 1,
      md_id: 0,
      md_title: '',
      Datalist: [],
      valid_edit_errMsg: '',
      valid_item_name: '',
      sort_disabled: true, // 排序功能是否停用
      btn_order: true, // 上方[重新排序]按鈕是否顯示
      item_name: '',
      mode: 'add',
      mdTitle: '',
      search: {}
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F28') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.getMenuItemList()
    var params = this.$route.params
    this.search = params.search
  },
  computed: {
    // 排序參數設定
    dragOptions () {
      return {
        disabled: this.sort_disabled
      }
    }
  },
  methods: {
    confirm () {
      this.$refs.mdEdit.hide()
      this.$parent.Loading = true

      return axios.post(API_URL + '/web/shopping/flavorItemCreate', {
        flavorID: this.$route.params.menuid,
        itemName: this.item_name
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('新增成功')
            this.afterEdit()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    // 取得已選商品列表
    getMenuItemList () {
      if (this.$route.params.menuid === undefined) {
        this.$router.push({ name: 'menu_list' })
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getFlavorItem', {
        flavorid: this.$route.params.menuid
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.Datalist = response.data.data
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            console.log(response)
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    afterEdit () {
      this.getMenuItemList()
      this.item_name = ''
    },
    // APP分類設定 - 按下重新排序按鈕
    editOrderBy () {
      this.btn_order = false
      this.sort_disabled = false // 啟用排序
    },
    // APP分類設定 - 按下排序儲存按鈕
    OrderByOpen () {
      this.$refs.mdOrder.show()
      this.sort_action = 2
    },
    // APP分類設定 - 儲存新的排序
    orderConfirm () {
      // 取得id與新的排序
      var arrAll = []
      this.Datalist.forEach(function (arrRole, Index) {
        arrAll.push({
          id: arrRole.ID,
          sort: Index + 1
        })
      })
      // call API
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/flavorItemOrder', {
        data: arrAll,
        flavorid: this.$route.params.menuid
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('重新排序成功')
            this.sort_action = 2
            this.mdOrderCancel()
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    mdOrderCancel () {
      this.$refs.mdOrder.hide()
      this.sort_action = 1
      this.orderCancel()
    },
    // APP分類設定 - 排序取消
    orderCancel () {
      this.btn_order = true
      this.sort_disabled = true // 停用排序
      this.getMenuItemList()
    },
    // APP分類設定 - 按下列表刪除按鈕
    delByOpen (item) {
      this.md_id = item.ID
      this.md_title = item.ItemName
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/flavorItemDelete', {
        id: this.md_id,
        flavorid: this.$route.params.menuid
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('已刪除')
            this.getMenuItemList()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    // APP分類設定 - 按下列表編輯按鈕
    editByOpen (mode, item) {
      this.mode = mode
      if (mode === 'edit') {
        this.md_id = item.ID
        this.item_name = item.ItemName
        this.mdTitle = '修改調味項目'
      } else {
        this.mdTitle = '新增調味項目'
      }
      this.$refs.mdEdit.show()
    },
    editCancel () {
      this.$refs.mdEdit.hide()
      this.editClear()
    },
    editConfirm () {
      this.$refs.mdEdit.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/flavorItemUpdate', {
        id: this.md_id,
        itemName: this.item_name
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.getMenuItemList()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    editsave () {
      this.valid_edit_errMsg = false
      if (!this.item_name) {
        this.valid_edit_errMsg = true
        this.valid_item_name = '調味項目名稱為必填'
      } else {
        this.valid_item_name = ''
      }
      if (this.valid_edit_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      if (this.mode === 'edit') {
        this.editConfirm()
      } else {
        this.confirm()
      }
    },
    editClear () {
      this.item_name = ''
      this.valid_item_name = ''
    }
  }
}
</script>
<style scoped>
.table-move>tbody>tr {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/flavor/ItemList.vue